import React from 'react';
import PropTypes from 'prop-types';

// Input custom (from scratch) — remplace l'Input de reactstrap.
// Reproduit la logique de classes reactstrap :
//   form-control (défaut), form-select (type select), form-check-input
//   (checkbox/radio/switch), form-range (range), form-control-plaintext.
//   + is-invalid / is-valid, + form-control-{bsSize}.
// Le type "switch" rend un <input type="checkbox"> (le style switch vient du
// FormGroup parent `.form-switch`).
const Input = ({
  className,
  type = 'text',
  bsSize,
  valid,
  invalid,
  tag,
  plaintext,
  innerRef,
  children,
  ...attributes
}) => {
  const checkInput = ['switch', 'radio', 'checkbox'].includes(type);
  const textareaInput = type === 'textarea';
  const selectInput = type === 'select';
  const rangeInput = type === 'range';

  let Tag = tag || (selectInput || textareaInput ? type : 'input');

  let formControlClass = 'form-control';
  if (plaintext) {
    formControlClass = 'form-control-plaintext';
    Tag = tag || 'input';
  } else if (rangeInput) {
    formControlClass = 'form-range';
  } else if (selectInput) {
    formControlClass = 'form-select';
  } else if (checkInput) {
    formControlClass = 'form-check-input';
  }

  const classes = [
    invalid && 'is-invalid',
    valid && 'is-valid',
    bsSize ? (selectInput ? `form-select-${bsSize}` : `form-control-${bsSize}`) : false,
    formControlClass,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const tagProps = { ...attributes };
  if (Tag === 'input') {
    tagProps.type = type === 'switch' ? 'checkbox' : type;
  }

  return (
    <Tag {...tagProps} ref={innerRef} className={classes} aria-invalid={invalid}>
      {selectInput || textareaInput ? children : undefined}
    </Tag>
  );
};

Input.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  bsSize: PropTypes.oneOf(['sm', 'lg']),
  valid: PropTypes.bool,
  invalid: PropTypes.bool,
  plaintext: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  children: PropTypes.node,
};

export default Input;
